import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Circle } from 'page/catalog/Circle/Circle'
import { demo } from 'page/catalog/store/CatalogStore'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'
import { ui } from 'store/home/ui/HomeUiStore'
import { formatPhone } from 'util/phone'
import { emdash } from 'util/typo'
import css from './UserCard.module.scss'

export const UserCard = observer(() => {
  const be = demo.it.by_email
  const bc = demo.it.by_card
  const { small } = ui.window
  const store = userModal.it
  const { name, phone, email, card, picture } = store.data ?? {}
  const info = be ? email : bc ? card : formatPhone(phone)

  const onLogout = useLatestCallback(() => {
    store.logout()
  })

  const onEdit = useLatestCallback(() => {
    store.startEdit(store.data)
  })

  if (small) return (
    <Space className={css.card}>
      <Space className={css.inner} gap={12} pad={12} opposite>
        <Space gap={12} opposite oh>
          <Circle size={48} image={picture} icon="person" />
          <Vertical gap={0} oh>
            <Typo size={13} medium upper ellipsis>
              {name || emdash}
            </Typo>
            <Typo size={13} secondary ellipsis>
              {info || emdash}
            </Typo>
          </Vertical>
        </Space>
        <Space gap={8}>
          <Button large action={onEdit}>
            <Icon size={16} name="edit" />
          </Button>
          <Button large action={onLogout}>
            <Icon size={16} name="logout" error />
          </Button>
        </Space>
      </Space>
    </Space>
  )

  return <Vertical className={css.card} center>
    <Vertical className={css.inner} gap={8} pad={12} center>
      <Circle size={64} image={picture} icon="person" />
      <Vertical gap={0} wide oh>
        <Typo size={13} center medium upper ellipsis>
          {name || emdash}
        </Typo>
        <Typo size={13} center secondary ellipsis>
          {info || emdash}
        </Typo>
      </Vertical>
      <Button gap={8} large wide action={onEdit}>
        <Icon size={16} name="edit" />
        {i18n('CustomerEdit')}
      </Button>
      <Space pin={[4, 4, null, null]}>
        <Button large action={onLogout}>
          <Icon size={16} name="logout" error />
        </Button>
      </Space>
    </Vertical>
  </Vertical>
})
